import { map, take } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { getHaulerState, OrderBuilderState } from '../../../../../reducers';
import { IHaulerState } from '../../../reducers/hauler-reducer/hauler.reducer';
import { HaulerSetAction } from '../../../actions/hauler-actions/hauler.actions';
import { IHauler } from '@cemex-core/cmx-api/models/hauler';

@Injectable()
export class HaulerSetCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    this.store
      .select(getHaulerState)
      .pipe(
        take(1),
        map((state: IHaulerState) => {
          return state.haulers.find((hauler: IHauler) => {
            return hauler.haulerId === value;
          });
        }),
      )
      .subscribe((hauler: IHauler) => this.store.dispatch(new HaulerSetAction(hauler)));
  }
}
